'use client';

import styles from './styles.module.css';

type Props = {
  currentStep: number;
  totalSteps: number;
  labelId?: string;
};

export function StepProgressBar({ currentStep, totalSteps, labelId }: Props) {
  if (currentStep < 0 || totalSteps <= 0 || currentStep > totalSteps) {
    return null;
  }

  const progress = (currentStep / totalSteps) * 100;

  return (
    <>
      {/* To inform screen readers of the current step */}
      <div aria-live="polite" className={styles.visuallyHidden}>
        {`Step ${currentStep} of ${totalSteps}`}
      </div>
      <div
        className={styles.progressionBarContainer}
        role="progressbar"
        aria-labelledby={labelId}
        aria-valuenow={currentStep}
        aria-valuemin={0}
        aria-valuemax={totalSteps}
      >
        <div
          aria-hidden="true"
          className={`${styles.progressionBar} ${currentStep === totalSteps ? styles.progressionBarCompleted : ''}`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </>
  );
}
